import { Link } from "react-router-dom";
import AltBankColoredLogo from "../../assets/icons/AltBankColoredLogo";
import AltBankWhiteLogo from "../../assets/icons/AltBankWhiteLogo";
interface AltBankLogoProps {
  colored: boolean;
  className: string;
}
const AltBankLogo: React.FC<Partial<AltBankLogoProps>> = ({
  colored,
  className,
}) => {
  return (
    <Link to="/" className={className}>
      {colored ? <AltBankColoredLogo /> : <AltBankWhiteLogo />}
    </Link>
  );
};

export default AltBankLogo;
